/*
 * @Author: chengyu
 * @Date: 2022-10-11 19:44:28
 * @Description: 浏览器下，实现同小程序一样的storage接口
 */
/**
 * 计算localStorage当前存储大小，返回值单位KB
 * https://gist.github.com/tkambler/71050d80f1a57ea83c18
 */
function getLocalStorageSize() {
    var total = 0;
    for (var x in window.localStorage) {
        // Value is multiplied by 2 due to data being stored in `utf-16` format,
        // which requires twice the space.
        var amount = (window.localStorage[x].length * 2) / 1024;
        // eslint-disable-next-line no-prototype-builtins
        if (!window.isNaN(amount) && window.localStorage.hasOwnProperty(x)) {
            total += amount;
        }
    }
    return total;
}
/**
 * 获取localStorage存储的所有key
 */
function getKeys() {
    var keys = [];
    for (var x in window.localStorage) {
        // eslint-disable-next-line no-prototype-builtins
        if (window.localStorage.hasOwnProperty(x)) {
            keys.push(x);
        }
    }
    return keys;
}
/**
 * 实现类似于微信小程序一致的Storage API
 */
var StorageBrowser = /** @class */ (function () {
    function StorageBrowser() {
    }
    StorageBrowser.prototype.getStorageSync = function (key) {
        var value = window.localStorage.getItem(key);
        if (value == null)
            return undefined;
        return JSON.parse(value);
    };
    StorageBrowser.prototype.setStorageSync = function (key, value) {
        window.localStorage.setItem(key, JSON.stringify(value));
    };
    StorageBrowser.prototype.removeStorageSync = function (key) {
        window.localStorage.removeItem(key);
    };
    StorageBrowser.prototype.getStorageInfoSync = function () {
        return {
            currentSize: getLocalStorageSize(),
            keys: getKeys(),
            /**
             * 浏览器最大存储上限默认5M
             */
            limitSize: 5 * 1024,
        };
    };
    return StorageBrowser;
}());
export default StorageBrowser;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZUJyb3dzZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29yZS9zdG9yYWdlQnJvd3Nlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7OztHQUlHO0FBUUg7OztHQUdHO0FBQ0gsU0FBUyxtQkFBbUI7SUFDMUIsSUFBSSxLQUFLLEdBQUcsQ0FBQyxDQUFDO0lBRWQsS0FBSyxJQUFNLENBQUMsSUFBSSxNQUFNLENBQUMsWUFBWSxFQUFFO1FBQ25DLHdFQUF3RTtRQUN4RSxrQ0FBa0M7UUFDbEMsSUFBTSxNQUFNLEdBQUcsQ0FBQyxNQUFNLENBQUMsWUFBWSxDQUFDLENBQUMsQ0FBQyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUM7UUFFMUQsaURBQWlEO1FBQ2pELElBQUksQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxJQUFJLE1BQU0sQ0FBQyxZQUFZLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQyxFQUFFO1lBQ2xFLEtBQUssSUFBSSxNQUFNLENBQUM7U0FDakI7S0FDRjtJQUVELE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQztBQUVEOztHQUVHO0FBQ0gsU0FBUyxPQUFPO0lBQ2QsSUFBTSxJQUFJLEdBQWEsRUFBRSxDQUFDO0lBRTFCLEtBQUssSUFBTSxDQUFDLElBQUksTUFBTSxDQUFDLFlBQVksRUFBRTtRQUNuQyxpREFBaUQ7UUFDakQsSUFBSSxNQUFNLENBQUMsWUFBWSxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUMsRUFBRTtZQUN6QyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDO1NBQ2Q7S0FDRjtJQUVELE9BQU8sSUFBSSxDQUFDO0FBQ2QsQ0FBQztBQUVEOztHQUVHO0FBQ0g7SUFBQTtJQXNCQSxDQUFDO0lBckJDLHVDQUFjLEdBQWQsVUFBZSxHQUFXO1FBQ3hCLElBQU0sS0FBSyxHQUFHLE1BQU0sQ0FBQyxZQUFZLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQy9DLElBQUksS0FBSyxJQUFJLElBQUk7WUFBRSxPQUFPLFNBQVMsQ0FBQztRQUNwQyxPQUFPLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDM0IsQ0FBQztJQUNELHVDQUFjLEdBQWQsVUFBZSxHQUFXLEVBQUUsS0FBUTtRQUNsQyxNQUFNLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxHQUFHLEVBQUUsSUFBSSxDQUFDLFNBQVMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDO0lBQzFELENBQUM7SUFDRCwwQ0FBaUIsR0FBakIsVUFBa0IsR0FBVztRQUMzQixNQUFNLENBQUMsWUFBWSxDQUFDLFVBQVUsQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUN0QyxDQUFDO0lBQ0QsMkNBQWtCLEdBQWxCO1FBQ0UsT0FBTztZQUNMLFdBQVcsRUFBRSxtQkFBbUIsRUFBRTtZQUNsQyxJQUFJLEVBQUUsT0FBTyxFQUFFO1lBQ2Y7O2VBRUc7WUFDSCxTQUFTLEVBQUUsQ0FBQyxHQUFHLElBQUk7U0FDcEIsQ0FBQztJQUNKLENBQUM7SUFDSCxxQkFBQztBQUFELENBQUMsQUF0QkQsSUFzQkM7QUFFRCxlQUFlLGNBQWMsQ0FBQyJ9